import { render, staticRenderFns } from "./activityResource.vue?vue&type=template&id=5e255304&scoped=true"
import script from "./activityResource.vue?vue&type=script&lang=js"
export * from "./activityResource.vue?vue&type=script&lang=js"
import style0 from "./activityResource.vue?vue&type=style&index=0&id=5e255304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e255304",
  null
  
)

export default component.exports